import React from 'react'
import DropDown from '../dropdown';
import { useTextResources } from '../../../language';



const FolioTypesDropDown = ({ ...props }) => {
    const text = useTextResources()
    const types = [
        {
            Id: 1, Name: text("FolioWithReservation")
        },
        {
            Id: 2, Name: text("FolioWithoutReservation")
        }
    ]
    return <DropDown search={false} data={types} textField="Name" valueField="Id" placeholder={text("All")}  {...props} />
}

export default FolioTypesDropDown